import React from "react";
import { Badge, User } from "@ecologi/shared";
import { twitterHandle } from "../../consts/socials.constants";
import styles from "../styles/AchievementPopup.module.scss";

interface Props {
  badge: Badge;
  user: User;
}

export const PopupShareView: React.FC<Props> = (props) => {
  const { badge, user } = props;
  const shareImageURL = `https://offset-earth-share-images.s3-eu-west-1.amazonaws.com/achievements/share_${badge.id}.png`;
  const shareURL = `${window.location.origin}/${user.username}/badges?share=${badge.id}`;

  return (
    <div className={styles.content}>
      <img
        alt={`${badge.title} social share`}
        className={styles.shareImage}
        src={shareImageURL}
      />
      <h3 className={styles.title}>Share this great news</h3>
      <p className={styles.copy}>Select which channel you want to post to:</p>
      <div className={styles.shareButtons}>
        <a
          className={styles.shareButton}
          data-network="facebook"
          href={`https://www.facebook.com/sharer/sharer.php?u=${shareURL}`}
          rel="noopener noreferrer"
          target="_blank"
          title="Share to Facebook"
        />
        <a
          className={styles.shareButton}
          data-network="instagram"
          download={`${badge.title}.png`}
          href={shareImageURL}
          title="Share to Instagram"
        />
        <a
          className={styles.shareButton}
          data-network="linkedin"
          href={`http://www.linkedin.com/shareArticle?mini=true&url=${shareURL}`}
          rel="noopener noreferrer"
          target="_blank"
          title="Share to LinkedIn"
        />
        <a
          className={styles.shareButton}
          data-network="twitter"
          href={`http://www.twitter.com/intent/tweet?url=${shareURL}&via=${twitterHandle}`}
          rel="noopener noreferrer"
          target="_blank"
          title="Share to Twitter"
        />
      </div>
    </div>
  );
};
